import type { FeedbackAdminApi } from '../adminApi.js'
import type { FeedbackApi } from '../components/feedbackApi.js'

/** The admin calls this screen uses. */
type AdminApi = FeedbackAdminApi

/** The feedback button's view of the admin area: sends as the admin, and "sent so far" is the whole list. */
export function adminFeedbackApi(api: Pick<AdminApi, 'listFeedback' | 'submitFeedback'>): FeedbackApi {
  return {
    area: 'admin',
    submit: api.submitFeedback,
    listMine: api.listFeedback,
    queryKey: ['admin', 'feedback'],
  }
}
